import { type Rect, type Vector2 } from '@kite/engine';

/*
 * A crowded field is a better outcome than a hung frame, so after this many tries the last point is
 * kept whether it cleared the exclusion or not.
 */
const MAX_ATTEMPTS = 12;

/** Writes a uniformly random point inside `area` into `out`, and returns it. */
export function randomPointIn(area: Rect, out: Vector2): Vector2 {
  return out.set(area.x + Math.random() * area.width, area.y + Math.random() * area.height);
}

/**
 * Moves `position` to a random point in `area`, at least `clearance` away from `avoid`.
 *
 * The exclusion is what stops a collected coin reappearing under the car that just took it, which
 * would read as one touch scoring twice and would keep the chime firing every frame.
 */
export function moveClearOf(position: Vector2, area: Rect, avoid: Vector2 | undefined, clearance: number): void {
  for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt += 1) {
    randomPointIn(area, position);
    if (avoid === undefined || position.distanceTo(avoid) >= clearance) {
      return;
    }
  }
}
